
function convertOuncesToGrams(num){
  let eq = 'Converting ' + num +" ounces To grams: \n"+
    num +" / 0.035274 = ";
  let rep = num / 0.035274;
  return eq + rep.toFixed(3);
}

function convertOuncesToPounds(num){
  let eq = 'Converting ' + num +" ounces to pounds: \n"+
    num +" * 0.062500 = ";
  let rep = num * 0.062500;
  return eq + rep.toFixed(3);
}

function convertOuncesToStones(num){
  let eq = 'Converting ' + num +" ounces to stones:  \n"+
    num +" * 0.0044643 = ";
  let rep = num * 0.0044643 ;
  return eq + rep.toFixed(5);
}

function convertOuncesToKilograms(num){
  let eq = 'Converting ' + num +" ounces to kilograms: \n"+
    num +" / 35.274 = ";
  let rep = num / 35.274;
  return eq + rep.toFixed(3);
}

export {
  convertOuncesToKilograms, convertOuncesToStones,
  convertOuncesToPounds, convertOuncesToGrams};
